<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-row class="hidden-sm-and-down">
            <v-col>
            </v-col>
            <div v-for="(button, index) in buttons"
                 :key="index"
            >
                <v-col
                        v-if="visibleButtons !== undefined && visibleButtons.hasOwnProperty(button.emitAction)
                                    ? (visibleButtons[button.emitAction] !== 0) : true"
                        class="mx-0 px-0"
                >
                    <v-tooltip left bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    fab
                                    dark
                                    small
                                    depressed
                                    :color="button.color"
                                    @click="$emit(button.emitAction)"
                                    v-on="on"
                                    class="mx-0 px-1"
                            >
                                <v-icon>{{button.icon}}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{button.title}}</span>
                    </v-tooltip>
                </v-col>
            </div>
        </v-row>
        <v-menu>
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="hidden-md-and-up"><v-icon >add</v-icon></v-btn>
            </template>
            <v-list>
                    <v-list-item
                            v-for="(button, index) in buttons"
                            :key="index"
                            v-show=" visibleButtons !== undefined && visibleButtons.hasOwnProperty(button.emitAction)
                                    ? (visibleButtons[button.emitAction] !== 0) : true"
                            class="mx-0 px-0"
                            @click="$emit(button.emitAction)"
                    >
                        <v-list-item-title

                        >
                            <v-icon>{{button.icon}}</v-icon>
                            {{button.title}}
                        </v-list-item-title>
                    </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: 'MessageMagic',
        props: ['messageModel', 'visibleButtons'],
        data() {
            return {
                direction: 'bottom',
                fab: false,
                buttons: [
                    {
                        title: 'Добавить/изменить клавиатуру',
                        icon: 'keyboard',
                        emitAction: 'visKeyboardForm',
                        color: 'blue lighten-2'
                    },
                    {
                        title: 'Добавить/изменить прикрепления',
                        icon: 'photo_library',
                        emitAction: 'visAttachmentForm',
                        color: 'blue lighten-2'
                    },
                    {
                        title: 'Ключевые слова для поиска',
                        icon: 'search',
                        emitAction: 'findWordBlock',
                        color: 'blue lighten-2'
                    },
                    {
                        title: 'Добавить модуль',
                        icon: 'category',
                        emitAction: 'moduleBlock',
                        color: 'blue lighten-2'
                    },
                    {
                        title: 'Цепочка сообщений',
                        icon: 'playlist_add',
                        emitAction: 'chainBlock',
                        color: 'blue lighten-2'
                    },
                    {
                        title: 'Переходы',
                        icon: 'link',
                        emitAction: 'jumpInfoDialog',
                        color: 'blue lighten-2'
                    }
                ]
            }
        },
        computed: {}
    }
</script>

<style scoped>

</style>
